<template>
  <div class="background">
    <div class="background-layer background-layer-garland"></div>
    <div class="background-layer background-layer-2"></div>

    <div class="content">
      <div class="background-layer background-layer-sparkle-1"></div>
      <div class="background-layer background-layer-sparkle-2 sparkle-2"></div>
      <div class="background-layer background-layer-sparkle-3 sparkle-2"></div>
      <div class="background-layer background-layer-sparkle-4 sparkle-2"></div>

      <div class="background-layer background-layer-sparkle-1"></div>
      <div class="background-layer background-layer-sparkle-2 sparkle-2"></div>
      <div class="background-layer background-layer-sparkle-3 sparkle-2"></div>
      <div class="background-layer background-layer-sparkle-4 sparkle-2"></div>

      <img
        class="mandarin"
        src="@/assets/img/mandarin-prediction/mandarin-prediction.png"
        alt="prediction"
      />

      <div class="prediction-card">
        {{ prediction }}
      </div>
    </div>

    <div class="buttons">
      <app-btn class="button--go-back">
        <div class="button-content" @click="$router.push({ name: 'Home' })">
          <img
            height="23"
            src="@/assets/img/mandarin-prediction/go-back-icon.svg"
          />
          Назад
        </div>
      </app-btn>
      <app-btn class="button--retry">
        <div
          class="button-content"
          @click="$router.push({ name: 'Predictions' })"
        >
          <img src="@/assets/img/mandarin-prediction/retry-icon.svg" />
          Выбрать еще раз
        </div>
      </app-btn>
      <app-btn class="button--share" v-if="!showShareButtons">
        <div class="button-content" @click="showShareButtons = true">
          <img src="@/assets/img/mandarin-prediction/share-icon.svg" />
          Поделиться с друзьями
        </div>
      </app-btn>

      <div class="buttons-share" v-else>
        <a
          class="link--share"
          v-for="button of shareButtons"
          :key="button.href"
          :href="button.href"
          target="_blank"
        >
          <img :src="button.icon" width="40" height="40" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import predictions from '@/data/mandarin-prediction/predictions.json'
import AppBtn from '@/components/UI/buttons/AppBtn.vue'

export default {
  name: 'Prediction',
  beforeRouteEnter(to, from, next) {
    if (!to.params.id) {
      const id = Math.floor(Math.random() * 38)

      next({
        name: to.name,
        params: { id },
      })
    } else next()
  },
  components: { AppBtn },
  data() {
    return {
      prediction: null,
      predictions,
      showShareButtons: false,
      shareButtons: [
        {
          href: `https://connect.ok.ru/offer?url=https://herbalifeacademy.ru/predictions/${
            this.$route.params.id
          }&imageUrl=${require('@/assets/img/mandarin-prediction/share-thumbnail.jpg')}`,
          icon: require(`@/assets/img/mandarin-prediction/ok-icon.svg`),
        },
        {
          href: `http://vk.com/share.php?url=https://herbalifeacademy.ru/predictions/${
            this.$route.params.id
          }&image=${require('@/assets/img/mandarin-prediction/share-thumbnail.jpg')}&image=https://herbalifeacademy.ru/predictions/${
            this.$route.params.id
          }/share_h.jpg&noparse=true`,
          icon: require(`@/assets/img/mandarin-prediction/vk-icon.svg`),
        },
        {
          href: `https://api.whatsapp.com/send?text=https://herbalifeacademy.ru/predictions/${this.$route.params.id}`,
          icon: require(`@/assets/img/mandarin-prediction/wa-icon.svg`),
        },
        {
          href: `https://t.me/share/url?url=https://herbalifeacademy.ru/predictions/${this.$route.params.id}`,
          icon: require(`@/assets/img/mandarin-prediction/tg-icon.svg`),
        },
      ],
    }
  },
  mounted() {
    this.prediction = predictions[this.$route.params.id - 1]
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mandarin-prediction/_fonts.scss';
@import '@/assets/scss/mandarin-prediction/_base.scss';

.background {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  background-image: url('~@/assets/img/mandarin-prediction/prediction/prediction-bg-1.png'),
    url('~@/assets/img/mandarin-prediction/background.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  overflow: hidden;
  position: relative;
  z-index: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  &-layer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    &-garland {
      width: 147.7vw;
      height: 96.11vw;
      left: -13vw;
      top: -31vh;
      transform: rotate(20.29deg);
      background-size: contain;
    }

    &-2 {
      background-image: url('~@/assets/img/mandarin-prediction/prediction/prediction-bg-2.png');
    }

    &-sparkle-1 {
      animation: mandarinSparkleRotate 2s linear infinite alternate both;
      transform: rotate(0);
      background-image: url('~@/assets/img/mandarin-prediction/prediction/prediction-sparkle-1.png');
      background-size: contain;
    }

    &.sparkle-2 {
      background-image: url('~@/assets/img/mandarin-prediction/prediction/prediction-sparkle-2.png');
      background-size: contain;
      width: 59.8vw;
      height: 24vh;
    }

    &-sparkle-2 {
      animation: mandarinSparkleRotate2 2s linear infinite alternate both;
      top: 49vh;
      left: 20vw;
      transform: rotate(95.92deg);
    }

    &-sparkle-3 {
      animation: mandarinSparkleRotate3 2s linear infinite alternate both;
      top: 46vh;
      left: 14.5vw;
      transform: rotate(81.03deg);
    }

    &-sparkle-4 {
      animation: mandarinSparkleRotate4 2s linear infinite alternate both;
      top: 46vh;
      left: 27.4vw;
      transform: rotate(98.97deg) scale(1, -1);
    }
  }
}

.content {
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 15;
    background-image: url('~@/assets/img/mandarin-prediction/pine.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}

.mandarin {
  width: 46.4vw;
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  transform: rotate(16.16deg);
}

.prediction-card {
  background: #ffffff;
  color: #565656;
  border-radius: 55px;
  padding: 33px 67px;
  font-size: 40px;
  font-family: 'Old Standard TT', sans-serif;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  width: max-content;
  max-width: 640px;
  text-align: center;
  white-space: pre-wrap;
}

.buttons {
  padding-bottom: 40px;
  position: relative;
  z-index: 100;
  display: flex;

  &-share {
    display: flex;
  }

  button {
    padding: 18px 37px;
    border-radius: 99px;

    .button-content {
      display: flex;
      align-items: center;
      font-family: 'M Plus Rounded 1c', sans-serif;
      font-weight: 800;
      font-size: 17px;
    }
  }

  .button--retry,
  .button--go-back {
    color: #aef53f;
    background: #1d360e;
    margin-right: 20px;

    img {
      margin-right: 25px;
    }
  }

  .button--share {
    color: #1d360e;
    background: #fff;

    img {
      margin-right: 15px;
    }
  }
}

.link--share {
  display: block;
  background: #fff;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:not(:first-child) {
    margin-left: 11px;
  }
}

@media (max-width: 900px) {
  .buttons {
    flex-direction: column-reverse;
    align-items: center;

    .button--retry,
    .button--go-back {
      color: #aef53f;
      background: #1d360e;
      margin-right: 0;
      margin-top: 20px;

      img {
        margin-right: 25px;
      }
    }
  }

  .mandarin {
    width: 87.2vw;
  }

  .background {
    background-image: url('~@/assets/img/mandarin-prediction/mobile/prediction-bg-1.png'),
      url('~@/assets/img/mandarin-prediction/mobile/background.png');

    &-layer {
      &-garland {
        width: 277vw;
        height: 84vh;
        top: 17vh;
        left: -66.7vw;
      }

      &-2 {
        background-image: url('~@/assets/img/mandarin-prediction/mobile/prediction-bg-2.png');
      }

      &-sparkle-1 {
        background-size: 193vw auto;
      }

      &.sparkle-2 {
        width: 112vw;
        height: 28.3vw;
      }

      &-sparkle-2 {
        top: 96vw;
        left: -13vw;
        transform: rotate(95.92deg);
      }

      &-sparkle-3 {
        top: 96vw;
        left: 7vw;
        transform: rotate(81.03deg);
      }

      &-sparkle-4 {
        top: 96vw;
        left: 8vw;
        transform: rotate(98.97deg) scale(1, -1);
      }
    }
  }

  .content {
    &::after {
      background-image: url('~@/assets/img/mandarin-prediction/mobile/pine.png');
      top: 5vh;
    }
  }
}

@media (max-width: 480px) {
  .prediction-card {
    border-radius: 28px;
    padding: 17px 34px;
    font-size: 20px;
    line-height: 24px;
    max-width: 320px;
    width: 100%;
  }
}

@media (max-width: 349px) {
  .buttons {
    button {
      padding: 14px 29px;
      border-radius: 99px;

      .button-content {
        font-size: 15px;
      }
    }
  }

  .content {
    &::after {
      top: 6vh;
    }
  }

  .prediction-card {
    max-width: 288px;
  }
}

@media (max-width: 480px) and (max-height: 800px) {
  .background {
    &-layer {
      &-sparkle-1 {
        top: -20vh;
      }

      &-sparkle-2 {
        top: 33vh;
        left: 0;
      }

      &-sparkle-3 {
        top: 30vh;
        left: -2vw;
      }

      &-sparkle-4 {
        top: 30vh;
        left: -6vw;
      }
    }
  }
  .content {
    &::after {
      top: -6vh;
    }
  }
  .mandarin {
    top: 15vh;
    bottom: auto;
  }
  .prediction-card {
    top: 37vh;
  }
}
</style>
